import React, { useContext, useEffect, useState, useRef } from 'react';
import { NavLink, useLocation, useNavigate, useSearchParams,useParams } from 'react-router-dom';
import { globalState } from '../../GlobalState/globalState';
import numeral from 'numeral';
import moment from 'moment';
import momenttz from 'moment-timezone';
import { addToCart, removeFromCart } from '../../GlobalState/globalStateActions';
import { ClipLoader } from 'react-spinners';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import customFetchData from '../../Components/Custom/customFetchData';
import { AiFillStar, AiOutlineClose } from 'react-icons/ai';
import ShareIcon from '../../Assets/vectorShareIcon.png'
import StarIconGreen from '../../Assets/material-symbols-star-rounded.png'
import { MdArrowBack, MdShoppingCart, MdClose, MdCheck } from 'react-icons/md';
import clockIcon from '../../Assets/clockIcon.png'
import upArrowSIncludes from '../../Assets/upArrowSIncludes.png'
import CancellationIllustration from '../../Assets/CancellationIllustration.png'
import Fee from '../../Assets/Fee.png'
import Certified from '../../Assets/Certified.png'
import Convenience from '../../Assets/Convenience.png'
import '../../CSS/UI Components/AthomeServiceAddOnsDetails.css';
import BookAserviceWithUs from '../../Components/Custom/UI/BookAserviceWithUs';
import {Helmet} from "react-helmet";
import { isAndroid, isIOS } from 'react-device-detect';

const DeepClone = require("rfdc/default");

export default function AthomeServiceAddOnsDetails() {
    const location = useLocation();
    let searchUrl = location.search
    const navigate = useNavigate();
    const [state, dispatch] = useContext(globalState);
    const params = location.state || {};

    const [proData, setProData] = useState(params.proData || []);
    const [serviceDetails, setServiceDetails] = useState({});
    const [couponDetails, setCouponDetails] = useState([]);
    const [ratingDetails, setRatingDetails] = useState([]);
    const [ratings1, setRatings1] = useState(0);
    const [ratings2, setRatings2] = useState(0);
    const [ratings3, setRatings3] = useState(0);
    const [ratings4, setRatings4] = useState(0);
    const [ratings5, setRatings5] = useState(0);
    const [totalRatings, setTotalRatings] = useState(0);
    const [avgRating, setAvgRating] = useState(0);
    const [isAddedToCart, setIsAddedToCart] = useState(false);
    const [loading, setLoading] = useState(false);
    const [cartAmount, setCartAmount] = useState(0);
    const [atHomeService, setAtHomeService] = useState(params.atHomeService === true);
    const [serviceReviews, setServiceReviews] = useState([]);
    const [viewMore, setViewMore] = useState(false);
    const [imageModalOpen, setImageModalOpen] = useState(false);
    const [imageData, setImageData] = useState({});
    const [nowOrNeverPopup, setNowOrNeverPopup] = useState(false);
    const [switchProAlert, setSwitchProAlert] = useState(false);
    const [diffProServiceCartCheck, setDiffProServiceCartCheck] = useState(false);
    const [sameServiceCheckCount, setSameServiceCheckCount] = useState(0);
    const [expandDescription, setExpandDescription] = useState(false);
    const [unlockedVisitationFee, setUnlockedVisitationFee] = useState(false);
    const [cleanDescription, setCleanDescription] = useState([]);
    const [keepinMind, setKeepinMind] = useState([]);
    const [cleanDescriptionLoading, setcleanDescriptionLoading] = useState(params && Object.keys(params.serviceDetails || {}).length && params.serviceDetails.category_name === 'Cleaning');
    const [repairViewModal, setRepairViewModal] = useState(false);
    const [serviceSpecificIssueArr, setServiceSpecificIssueArr] = useState([]);
    const [ratingViewShow, setRatingViewShow] = useState(false);
    const [showServiceIncludes, setShowServiceIncludes] = useState(true);
    const [filteredServiceReviews, setFilteredServiceReviews] = useState([]);
    const [finalArrAddOns, setFinalArrAddOns] = useState([]);
    const [mainHeaderTxt, setMainHeaderTxt] = useState('');
    const [checkedValues, setCheckedValues] = useState({});
    const [selectedValuesArr, setSelectedValuesArr] = useState([]);
    const [canAddToCart, setCanAddToCart] = useState(false);
    const [selectedTotalOfferPrice, setSelectedTotalOfferPrice] = useState(0);
    const [selectedTotalDuration, setSelectedTotalDuration] = useState(0);
    const [selectedTotalDisplayPrice, setSelectedTotalDisplayPrice] = useState(0);
    const [onClickServiceItem, setOnClickServiceItem] = useState(false);
    const [hasModifiedSelections, setHasModifiedSelections] = useState(false);
    const [serviceNotIncludes, setServiceNotIncludes] = useState([]);
    const [doneClicked, setDoneClicked] = useState(false);
    const [newVar, setNewVar] = useState(false);
    const [whatWeNeedFromYou, setWhatWeNeedFromYou] = useState([]);
    const [showFloatingBtn, setShowFloatingBtn] = useState(false);
    const [subCatName, setSubCatName] = useState('')
    const[categoryName,setCategoryName] = useState('')
    const scrollRef = useRef(null);
    const addToCartSectionRef = useRef(null);
    const { servicename } = useParams();
    useEffect(() => {
        const serviceDetailsFetch = async () => {
            console.log('params in details page', params.serviceDetails)
            setLoading(true);
            let regex = /[?&]([^=#]+)=([^&#]*)/g, searchParams = {}, match
            while ((match = regex.exec(searchUrl))) {
                searchParams[match[1]] = match[2]
            }
            let body = {
                serviceTemplateId: params.serviceDetails?params.serviceDetails.QF_AT_HOME_SERVICE_PRID : searchParams.serviceId,
                countryName: state.address.country ? state.address.country : 'India',
            };
            let serviceFetch = await customFetchData('POST', body, '/website/fetch/atHomeServiceDeatails/addOns/sv1', state, dispatch);
            console.log('serviceFetch', serviceFetch);
            
            if (serviceFetch.fetch && serviceFetch.fetchedData.offers.length !== 0) {
                setLoading(false);
                let serviceDetails = serviceFetch.fetchedData.offers[0];
                let mergedServiceDetails = {
                    ...serviceDetails,
                    serviceLocationPridArrUnique: params.serviceDetails?.serviceLocationPridArrUnique || [],
                };
                setFinalArrAddOns(serviceFetch.fetchedData.finalAddonsArr || []);
                setMainHeaderTxt(serviceFetch.fetchedData.mainHeaderTxt || '');
                setServiceDetails(mergedServiceDetails);
                renderDescription(serviceDetails.QF_AT_HOME_SERVICE_PRID)
                setServiceSpecificIssueArr(
                    serviceDetails.AT_HOME_SPECIFIC_ISSUE && JSON.parse(serviceDetails.AT_HOME_SPECIFIC_ISSUE).length !== 0
                        ? JSON.parse(serviceDetails.AT_HOME_SPECIFIC_ISSUE)
                        : []
                );
                if (Object.keys(serviceDetails).length !== 0) {
                    ratingsFetchHandler(serviceDetails.QF_AT_HOME_SERVICE_PRID);
                }
            setSubCatName(params.serviceDetails?.service_sub_category_name || '');
            setCategoryName(params.serviceDetails?.category_name || '');
            } else {
                setLoading(false);
                setServiceDetails({});
                setFinalArrAddOns([]);
            }
        };
        serviceDetailsFetch();
    }, []);

    useEffect(() => {
        const cartItem = state.cart.find(item => item.QF_AT_HOME_SERVICE_PRID === serviceDetails.QF_AT_HOME_SERVICE_PRID);
        if (cartItem && cartItem.addOnsArray) {
            setSelectedValuesArr(cartItem.addOnsArray);
            const checkedObj = {};
            cartItem.addOnsArray.forEach(addOn => {
                if (!checkedObj[addOn.groupId]) checkedObj[addOn.groupId] = {};
                checkedObj[addOn.groupId][addOn.subServicePrid] = true;
            });
            setCheckedValues(checkedObj);
        } else {
            setSelectedValuesArr([]);
            setCheckedValues({});
        }
    }, [state.cart, serviceDetails]);

    useEffect(() => {
        if (Object.keys(serviceDetails).length !== 0) {
            calculateOfferPriceHandler(serviceDetails);
        }
    }, [selectedValuesArr, serviceDetails]);

    const calculateOfferPriceHandler = (serviceDetails) => {
        let basePrice = Number(serviceDetails.service_offer_price) || 0;
        let addOnsTotal = selectedValuesArr.reduce((sum, item) => sum + (Number(item.price) || 0), 0);
        setSelectedTotalOfferPrice(basePrice + addOnsTotal);
        
        let baseDuration = Number(serviceDetails.AT_HOME_SERVICE_DURATION) || 0;
        let totalDuration = selectedValuesArr.reduce((sum, item) => sum + (Number(item.duration) || 0), 0);
        setSelectedTotalDuration(baseDuration + totalDuration);
        
        let baseDisplayPrice = Number(serviceDetails.service_list_price) || 0;
        let addOnsDisplayTotal = selectedValuesArr.reduce((sum, item) => sum + (Number(item.displayPrice) || 0), 0);
        setSelectedTotalDisplayPrice(baseDisplayPrice + addOnsDisplayTotal);
    };

    const ratingsFetchHandler = async (serviceId) => {
        let body = { m_serviceId: serviceId };
        let ratingFetch = await customFetchData('POST', body, '/website/atHomeServiceRatingsFetch/sv1', state, dispatch);
        
        if (ratingFetch.fetch && ratingFetch.fetchedData.data && ratingFetch.fetchedData.ratingsResult.length !== 0) {
            setRatingDetails(ratingFetch.fetchedData.ratingsResult);
            setTotalRatings(ratingFetch.fetchedData.totalRatings);
            setRatings1(ratingFetch.fetchedData.ratings1);
            setRatings2(ratingFetch.fetchedData.ratings2);
            setRatings3(ratingFetch.fetchedData.ratings3);
            setRatings4(ratingFetch.fetchedData.ratings4);
            setRatings5(ratingFetch.fetchedData.ratings5);
            setAvgRating(ratingFetch.fetchedData.avgRating);
        }

        let reviewsFetch = await customFetchData('POST', body, '/website/serviceDetailsReviews/sv2', state, dispatch);
        if (reviewsFetch.fetch && reviewsFetch.fetchedData.serviceReviews.length !== 0) {
            setServiceReviews(reviewsFetch.fetchedData.serviceReviews);
        }
    };
     const renderDescription = async (data) => {
        setcleanDescriptionLoading(true)
        let body = {
            servicePrid: data ? data : null,
            country: state.address.country ? state.address.country : 'India',
        }
        console.log("body for description", body)
        let description = await customFetchData('POST', body, '/website/atHomeService/description/includes/sv1', state, dispatch, null, null, null)
        console.log("description", description)
        if (description.fetch) {
            if (description.fetchedData.data) {
                setcleanDescriptionLoading(false)

                if (description.fetchedData.whatWeNeedFromYou.length !== 0) {
                    // console.log('Description', description)
                    setWhatWeNeedFromYou(description.fetchedData.whatWeNeedFromYou)
                }
                else {
                    setWhatWeNeedFromYou([])
                }
                 
                if (description.fetchedData.serviceNotIncludesArray.length !== 0) {
                    // console.log('Description', description)
                    setServiceNotIncludes(description.fetchedData.serviceNotIncludesArray)
                }
                else {
                    setServiceNotIncludes([])
                }
                if (description.fetchedData.serviceIncludesArray.length !== 0) {
                    // console.log('Description', description)
                    setCleanDescription(description.fetchedData.serviceIncludesArray)
                }
                else {
                    setCleanDescription([])
                }
                if (description.fetchedData.keepInMind.length !== 0) {
                    // console.log('keepInMind', description)
                    setKeepinMind(description.fetchedData.keepInMind)
                }
                else {
                    setKeepinMind([])
                }
            }
            else {
                setcleanDescriptionLoading(false)
                setKeepinMind([])
                setCleanDescription([])
            }
        } else {
            setcleanDescriptionLoading(false)
            setKeepinMind([])
            setCleanDescription([])
        }

    }
    const onAddToCart = async (cartData) => {
        let data = DeepClone(cartData);
        data.addOnsArray = selectedValuesArr;
        data.service_offer_price = selectedTotalOfferPrice;
        data.finalDuration = selectedTotalDuration;
        data.addOnServicesDuration = selectedValuesArr.reduce((sum, item) => sum + (Number(item.duration) || 0), 0);
        data.service_type = "at_home";
        data.athomeFlagCheck = true;

        let cart = DeepClone(state.cart);
        if (state.cart.length !== 0) {
            let allAreAthomeCheck = cart.every((item) => item.service_type === data.service_type);
            if (allAreAthomeCheck) {
                addToCart(data, state, dispatch);
            } else {
                setDiffProServiceCartCheck(true);
            }
        } else {
            setOnClickServiceItem(false);
            addToCart(data, state, dispatch);
        }
    };

    const onRemoveFromCart = async (data1) => {
        let cartValues = DeepClone(state.cart);
        cartValues = cartValues.filter(item => item.QF_AT_HOME_SERVICE_PRID === data1.QF_AT_HOME_SERVICE_PRID);
        let data = cartValues[0];
        removeFromCart(data, state, dispatch);
    };

    const checkHandler = (groupId, item) => {
        setOnClickServiceItem(true);
        setDoneClicked(false);
        
        if (item.selectionType === 'multiple') {
            setCheckedValues(prev => {
                const updated = { ...prev };
                if (!updated[groupId]) updated[groupId] = {};
                updated[groupId][item.subServicePrid] = !updated[groupId][item.subServicePrid];
                return updated;
            });
            setSelectedValuesArr(prev => {
                const exists = prev.some(i => i.subServicePrid === item.subServicePrid);
                const newArr = exists
                    ? prev.filter(i => i.subServicePrid !== item.subServicePrid)
                    : [...prev, item];
                if (newArr.length === 0) {
                    setNewVar(true);
                }
                updateCanAddToCart(newArr, finalArrAddOns);
                
                const cartItem = state.cart.find(ci => ci.QF_AT_HOME_SERVICE_PRID === serviceDetails.QF_AT_HOME_SERVICE_PRID);
                if (cartItem) {
                    setHasModifiedSelections(checkIfSelectionsChanged(newArr, cartItem));
                }
                return newArr;
            });
        } else {
            setCheckedValues(prev => {
                const updated = { ...prev };
                updated[groupId] = {};
                updated[groupId][item.subServicePrid] = true;
                return updated;
            });
            setSelectedValuesArr(prev => {
                const filtered = prev.filter(i => i.groupId !== groupId);
                const newArr = [...filtered, item];
                updateCanAddToCart(newArr, finalArrAddOns);
                
                const cartItem = state.cart.find(ci => ci.QF_AT_HOME_SERVICE_PRID === serviceDetails.QF_AT_HOME_SERVICE_PRID);
                if (cartItem) {
                    setHasModifiedSelections(checkIfSelectionsChanged(newArr, cartItem));
                }
                return newArr;
            });
        }
    };

    const updateCanAddToCart = (selectedArr, groupsArr) => {
        const mandatoryGroups = groupsArr.filter(g => g.mandatoryFlag === 1).map(g => g.groupId);
        const allSelected = mandatoryGroups.every(groupId =>
            selectedArr.some(item => item.groupId === groupId)
        );
        setCanAddToCart(allSelected);
    };

    const checkIfSelectionsChanged = (currentSelections, cartItem) => {
        if (!cartItem || !cartItem.addOnsArray) return false;
        if (currentSelections.length !== cartItem.addOnsArray.length) return true;

        const cartPrids = new Set(cartItem.addOnsArray.map(a => a.subServicePrid));
        const currentPrids = new Set(currentSelections.map(a => a.subServicePrid));

        for (let prid of currentPrids) {
            if (!cartPrids.has(prid)) return true;
        }
        for (let prid of cartPrids) {
            if (!currentPrids.has(prid)) return true;
        }
        return false;
    };

    const onUpdateCartItem = () => {
        const cartItem = state.cart.find(item => item.QF_AT_HOME_SERVICE_PRID === serviceDetails.QF_AT_HOME_SERVICE_PRID);
        if (!cartItem) return;

        if (selectedValuesArr.length === 0) {
            const updatedCart = state.cart.filter(item =>
                item.QF_AT_HOME_SERVICE_PRID !== serviceDetails.QF_AT_HOME_SERVICE_PRID
            );
            dispatch({ type: 'ADD_TO_CART', cart: DeepClone(updatedCart) });
            dispatch({ type: 'UPDATE_CART_COUNT', cartCount: updatedCart.length });
            setHasModifiedSelections(false);
            setDoneClicked(true);
            setNewVar(false);
            return;
        }

        const updatedItem = {
            ...cartItem,
            addOnsArray: selectedValuesArr,
            service_offer_price: selectedTotalOfferPrice,
            service_list_price: selectedTotalDisplayPrice,
            finalDuration: selectedTotalDuration,
            addOnServicesDuration: selectedValuesArr.reduce((sum, item) => sum + (Number(item.duration) || 0), 0),
        };

        const updatedCart = state.cart.filter(item =>
            item.QF_AT_HOME_SERVICE_PRID !== serviceDetails.QF_AT_HOME_SERVICE_PRID
        );
        updatedCart.push(updatedItem);
        setDoneClicked(true);

        dispatch({ type: 'ADD_TO_CART', cart: DeepClone(updatedCart) });
        dispatch({ type: 'UPDATE_CART_COUNT', cartCount: updatedCart.length });
        setHasModifiedSelections(false);
    };

    const formatDuration = (minutes) => {
        const hrs = Math.floor(minutes / 60);
        const mins = minutes % 60;
        let result = '';
        if (hrs > 0) {
            result += hrs + (hrs === 1 ? ' hr' : ' hrs');
        }
        if (mins > 0) {
            if (result) result += ' ';
            result += mins + ' mins';
        }
        if (!result) result = '0 min';
        return result;
    };

    const showPlusForTens = (num) => {
        if (num < 10) return num.toString();
        const base = Math.floor(num / 10) * 10;
        return `${base}+`;
    };

    const navToLoginOrCheckout = () => {
        if (state.cart.length !== 0) {
            navigate(state.token ? '/checkout' : '/login', { state: { login: true } });
        }
    };
    const copyClipHandler = () => {
        // let code=window.location.href
        // navigator.clipboard.writeText(code)
        // toast(
        //   <div style={{display:'flex',justifyContent:'center',alignItems:'center'}}>
        //     <text>Copied to clipboard</text> 
        //   </div>,
        //   {
        //     position:'bottom-center',
        //     hideProgressBar: true,
        //     progress: undefined,
        //     closeButton:false,
        //     style:{backgroundColor:'#E0D1FF'}
        // });
    }
    const _renderCleanDescription1 = (data) => {
        // console.log('data in cleanDescription', data)
        return (
            <>
                {/* <text className='ourServiceHeadder'>{data.item.header}</text> */}
                <div style={{ flexDirection: 'row', justifyContent: 'space-between' }}>
                    <div style={{ minHeight: 200,marginTop:10}}>
                        {data.item.content.map((item) => {
                            return (
                                <div style={{ flexDirection: 'row', zIndex: 200 }}>
                                    <text className='contentStyle' style={ { zIndex: 200 }}>
                                        {'\u2022'}{" "}{item.detailDescContent}
                                    </text>
                                </div>
                            )

                        })
                        }
                        <image resizeMode="contain" src={data.item.image_link } style={{ height: '100%', width: '100%', flexDirection: 'row', justifyContent: 'flex-end', position: 'absolute', left: '37%', right: 20, top: 0 }} />
                    </div>

                </div>
            </>
        )

    }
    const _renderCleanDescription = (data) => {
        // console.log('data in Keepin Mind', data)
        return (
            // <div style={{ marginLeft: 15,marginRight:15, marginBottom: 20 }}>

                <div  style={{marginTop:10,marginBottom:10}}>
                    {data.item.content.map((item) => {
                            return (
                                <div style={{ flexDirection: 'row'}}>
                                    {/* <DotSingleIcon color="#000" size={15} name="dot-single" /> */}
                                     <text className='contentStyle' style={{ marginRight: 8, color: '#000' }}>•</text>
                                    <text className='contentStyle'>
                                        {item.detailDescContent}
                                    </text>
                                </div>
                            )

                        })
                        }
                </div>

            // </div>

        )

    }
    const _renderKeepInMind = (data) => {
        // console.log('data in Keepin Mind', data)
        return (
            // <div style={{ marginLeft: 15,marginRight:15, marginBottom: 20 }}>

                <div className='keepInMindBoxStyle' style={{marginTop:10,marginBottom:10}}>
                    {
                        data.item.image_link ?
                        <img src={data.item.image_link } style={{ height: 18, width: 18 }}/>
                        : null
                    }
                    <div style={{ width: '100%', marginLeft: data.item.image_link ? 10 : 0 }}>
                        <text className='contentStyle'>{data.item.content}</text>
                    </div>
                </div>

            // </div>

        )

    }
    const _renderServiceNotIncludes = (data) => {
        // console.log('data in Keepin Mind', data)
        return (
               <div style={{ flexDirection: 'row',display:'flex',marginTop:10,marginBottom:10,justifyContent:'flex-start',alignItems:'center' }}>
                    {
                        data.item.image_link ?
                        <img src={data.item.image_link } style={{ height: 30, width: 30 }}/>
                        : null
                    }
                    <div style={{ width: '100%', marginLeft: data.item.image_link ? 10 : 0 }}>
                        <text className='contentStyle'>{data.item.content}</text>
                    </div>
                </div>


        )

    }
    const _renderWhatWeNeedFromYou = (data) => {
        // console.log('data in Keepin Mind', data)
        return (
               <div style={{ flexDirection: 'row',display:'flex',marginTop:10,marginBottom:10,justifyContent:'flex-start',alignItems:'center' }}>
                    {
                        data.item.image_link ?
                        <img src={data.item.image_link } style={{ height: 30, width: 30 }}/>
                        : null
                    }
                    <div style={{ width: '100%', marginLeft: data.item.image_link ? 20 : 0 }}>
                        <text className='contentStyle'>{data.item.content}</text>
                    </div>
                </div>


        )
    }
const bookNowHandler = () => {
     const url = isAndroid?'https://play.google.com/store/apps/details?id=com.quickfinduser&utm_campaign=Consumer_Guide&utm_source=Website&utm_medium=DigitalMarketingSources':'https://apps.apple.com/us/app/slash-consumer/id1489207325?ls=1/?utm_campaign=Consumer_Guide&utm_source=Website&utm_medium=DigitalMarketingSources'
            window.location.href = url
}
    console.log('finalArrAddOns', finalArrAddOns)
    return (
        <div style={{marginTop:70,backgroundColor:'#e8e8e8',position: 'relative'}}>
            {/* <div className='MainContainer_AthomeServiceAddOnsDetails'>
            </div> */}
             <Helmet>
                <title>SLASH | {servicename ? servicename : ''} | {state.address.city ? state.address.city : ''}</title>
            </Helmet>
            <div style={{ display: 'flex', width: '100%',backgroundColor:'#f1f1f1',paddingBottom:40,flexDirection: 'column'}} ref={scrollRef}>
                {/* <div style={{ display: 'flex', flexDirection: 'column' }}> */}
                    <div style={{  }}>
                        <img src={serviceDetails.image_link} style={{ width: '100%', height: 220}} />
                        <div style={{ flexDirection: 'row', display: 'flex', justifyContent: 'space-between', position: 'absolute', top: 20, right: 20 }}>
                            <div style={{ display: 'flex', flexDirection: 'row', backgroundColor: '#000', borderRadius: 20, height: 40, width: 40, justifyContent: 'center', alignItems: 'center', opacity: 0.7, cursor: 'pointer' }} onClick={() => navigate(-1)}>
                                <div className='shareIconView_athomeSerDetDeepLink' onClick={() => copyClipHandler()}>
                                    <img src={ShareIcon} />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='athomeservice-info-card'>
                        
                            {/* {ratingDetails.length !== 0 && ( */}
                                <div className="rating-row">
                                    <div className="rating-badge">
                                        <span className='ratingValueText'>{avgRating ? avgRating : "4.5"}</span>
                                        <AiFillStar size={18} color="rgb(146,198,61)" />
                                    </div>
                                    {/* {serviceReviews.length > 0 && ( */}
                                        {/* <span className="reviews-count">{showPlusForTens(serviceReviews.length)} Reviews</span> */}
                                        <span className="reviews-count">10 Reviews</span>
                                    {/* )} */}
                                </div>
                                <h1 className="service-name">{serviceDetails.AT_HOME_SERVICE_NAME}</h1>
                            {/* )} */}
                            <div className="duration-row">
                                <img src={clockIcon} alt="duration" className="duration-icon" />
                                <span className="duration-text">
                                    {formatDuration(serviceDetails.AT_HOME_SERVICE_DURATION)}
                                </span>
                            </div>
                            <div className="price-row">
                                <span className="starting-text">Starting from</span>
                                <span className="strike-price">
                                    {serviceDetails.AT_HOME_CURRENCY === 'Rupees' ? '₹' : '$'}{serviceDetails.service_list_price}
                                </span>
                                <span className="offer-price">
                                    {serviceDetails.AT_HOME_CURRENCY === 'Rupees' ? '₹' : '$'}{serviceDetails.startingPriceForAddon}
                                </span>
                                <span className="discount-badge">{serviceDetails.service_discount}% off</span>
                            </div>
                    </div>
                    {/* <div style={{height:6,backgroundColor:'#e8e8e8'}}></div> */}
                    <div style={{marginTop:10}} className='athomeservice-info-card'>
                        {finalArrAddOns.length !== 0 && (
                            <div>
                                {mainHeaderTxt && <h2 className="addons-main-header">{mainHeaderTxt}</h2>}
                                {finalArrAddOns.map((group, index) => (
                                    <div key={index} className="addon-group">
                                        {group.groupName && (
                                            <div className="addon-group-header" style={{marginTop:20}}>
                                                <h3>{group.groupName}</h3>
                                            </div>
                                        )}
                                        <div className="addon-items">
                                            {group.addOnsArr.map((item, idx) => (
                                                <div
                                                    key={idx}
                                                    className={`addon-item ${checkedValues[item.groupId]?.[item.subServicePrid] ? 'selected' : ''}`}
                                                    onClick={() => checkHandler(item.groupId, item)}
                                                >
                                                    {item.image_link && (
                                                        <img src={item.image_link} alt={item.serviceName} className="addon-image" />
                                                    )}
                                                    <div className="addon-info">
                                                        <span className="addon-name">{item.serviceName}</span>
                                                        <div className="addon-price">
                                                            {item.price > 0 && (
                                                                <span className="addon-strike-price">
                                                                    {serviceDetails.AT_HOME_CURRENCY === 'Rupees' ? '₹' : '$'}{item.displayPrice}
                                                                </span>
                                                            )}
                                                            <span className="addon-offer-price">
                                                                {serviceDetails.AT_HOME_CURRENCY === 'Rupees' ? '₹' : '$'}{item.price}
                                                            </span>
                                                        </div>
                                                    </div>
                                                    {checkedValues[item.groupId]?.[item.subServicePrid] && (
                                                        <MdCheck size={18} color="#8c52ff" className="check-icon" />
                                                    )}
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                    <div className='addToCartButtonBox' style={{position:'fixed',bottom:0,right:0,left:0,backgroundColor:'#fff',zIndex:1000,marginTop:20,display:'flex',justifyContent:'space-between',alignItems:'center',flexDirection:'row'}} >
                        {
                            finalArrAddOns.length !== 0 ?
                            selectedValuesArr.length > 0 || newVar ?
                                <>
                                        
                                            <text className='finalPriceTextStyle'>
                                                {serviceDetails.AT_HOME_CURRENCY === 'Rupees' ? ('\u20B9') : '$'}{(selectedTotalOfferPrice || newVar) ? selectedTotalOfferPrice : serviceDetails.service_offer_price}
                                            </text>
                                
                                        {
                                            <div
                                                className='bookNowButtonStyle' onClick={bookNowHandler} >
                                                {
                                                    <text className='addToCartTextStyle'>
                                                        Book Now
                                                    </text>
                                                }
                                            </div>
                                        }
                                </>
                                :
                                null
                                :
                                 <>
                                        
                                            <text className='finalPriceTextStyle'>
                                                {serviceDetails.AT_HOME_CURRENCY === 'Rupees' ? ('\u20B9') : '$'}{serviceDetails.service_offer_price}
                                            </text>
                                
                                        {
                                            <div
                                                className='bookNowButtonStyle'onClick={bookNowHandler}>
                                                {
                                                    <text className='addToCartTextStyle'>
                                                        Book Now
                                                    </text>
                                                }
                                            </div>
                                        }
                                </>
                        }
                    </div>
                    {/* <div style={{height:90}}></div> */}
                {/* </div> */}
                {/* <div style={{ width: '3%', marginLeft: 10 }}>
                    <div className='verticalLine_serDetDeepLink'>
                    </div>
                </div> */}
                {/* <div style={{ display: 'flex', flexDirection: 'column'}}> */}
                    {
                        cleanDescription.length !== 0 ?
                            // showServiceIncludes ?
                            //     <div style={{ paddingTop: 20,paddingBottom:20,paddingLeft:20,paddingRight:20, backgroundColor: '#fff' }}>
                            //         <div onClick={()=>{}}>
                            //             <text className='serviceIncludesTitle'>{("What's Included ✅").toUpperCase()}</text>
                            //             <div onClick={() => setShowServiceIncludes(false)} style={ {alignItems: 'center', width: 20, height: 20, borderRadius: 10, backgroundColor: '#fff', justifyContent: 'center' }}>
                            //             </div>
                            //         </div>
                            //         {cleanDescription.map((item, index) => (
                            //             <React.Fragment key={index}>
                            //                 {_renderCleanDescription({ item, index })}
                            //             </React.Fragment>
                            //         ))}
                            //     </div>
                            //     :
                            //     <div onClick={() => setShowServiceIncludes(true)} style={{ flexDirection: 'row', justifyContent: 'space-between', paddingVertical: 20, paddingHorizontal: 16, marginTop: 15, backgroundColor: '#fff' }}>
                            //         <text>SERVICE INCLUDES</text>
                            //         <div onClick={() => setShowServiceIncludes(true)} style={ { alignItems: 'center', width: 20, height: 20, borderRadius: 10, backgroundColor: '#fff', justifyContent: 'center' }}>
                            //             <img src={upArrowSIncludes} style={{ transform: [{ rotate: '270deg' }], width: 15, height: 15, }} />
                            //         </div>
                            //     </div>
                                <div style={{ backgroundColor: "#fff",paddingTop:20,paddingBottom:20,paddingLeft:20,paddingRight:20 }}>
                                <text className='howItWork'>{("What's Included ✅").toUpperCase()}</text>
                                {cleanDescription.map((item, index) => (
                                    <React.Fragment key={index}>
                                        {_renderCleanDescription({ item, index })}
                                    </React.Fragment>
                                ))}
                            </div>
                            :
                            null
                    }
                    {
                        keepinMind.length !== 0 ?
                            <div style={{ backgroundColor: "#fff", marginTop: 15,paddingTop:20,paddingBottom:20,paddingLeft:20,paddingRight:20 }}>
                                <text className='howItWork'>Keep in mind</text>
                                {keepinMind.map((item, index) => (
                                    <React.Fragment key={index}>
                                        {_renderKeepInMind({ item, index })}
                                    </React.Fragment>
                                ))}
                            </div>

                            : null
                    }
                    {
                        serviceNotIncludes.length !== 0 ?
                            <div style={{ marginTop: 15,paddingTop:20,paddingBottom:20,backgroundColor: "#fff", marginTop: 15,paddingLeft:20,paddingRight:20 }}>
                                <text className='howItWork'>WHAT'S NOT INCLUDED ❌</text>
                                 {serviceNotIncludes.map((item, index) => (
                                    <React.Fragment key={index}>
                                        {_renderServiceNotIncludes({ item, index })}
                                    </React.Fragment>
                                ))}
                            </div>

                            : null
                    }
                    {
                        whatWeNeedFromYou.length !== 0 ?
                            <div style={{ marginTop: 15,paddingTop:20,paddingBottom:20,backgroundColor: "#fff", marginTop: 15,paddingLeft:20,paddingRight:20}}>
                                <text className='howItWork'>What we need from you</text>
                                {whatWeNeedFromYou.map((item, index) => (
                                    <React.Fragment key={index}>
                                        {_renderWhatWeNeedFromYou({ item, index })}
                                    </React.Fragment>
                                ))}
                            </div>
                            : null
                    }
                    <div style={{ marginTop: 10, padding: 20, backgroundColor: "#fff" ,display:'flex',flexDirection:'row',justifyContent:'space-between',alignItems:'center'}}>
                        <div style={{width:'70%'}}>
                            <div style={{flexDirection:'column',display:'flex'}}>
                                <text className='cancelPolicyTitleTextStyle'>Cancellation Policy</text>
                                <text className='cancelPolicyTextStyle' style={{marginTop:8}}>You can cancel anytime, even up to the last minute.</text>
                            </div>
                            <div style={{ flexDirection: 'row', alignItems: 'flex-start', paddingBottom: 6,paddingTop:6 }}>
                                <text style={{ marginRight: 10, fontSize: 16, color: '#747474', marginTop: -3 }}>{'\u2022'}</text>
                                <text className='cancelPolicyTextStyle'>Free cancellation until 24 hours before service.</text>
                            </div>
                            <div style={{ flexDirection: 'row', alignItems: 'flex-start', paddingBottom: 6 }}>
                                <text style={{ marginRight: 10, fontSize: 16, color: '#747474', marginTop: -3 }}>{'\u2022'}</text>
                                <text className='cancelPolicyTextStyle'>10% charge if cancelled within 24 hours.</text>
                            </div>
                            <div style={{ flexDirection: 'row', alignItems: 'flex-start' }}>
                                <text style={{ marginRight: 10, fontSize: 16, color: '#747474', marginTop: -3 }}>{'\u2022'}</text>
                                <text className='cancelPolicyTextStyle'>No refund if cancelled in the last 4 hours.</text>
                            </div>
                        </div>
                        <div style={{width:'30%'}}>
                            <img src={CancellationIllustration} style={{ height: 100, width: 100 }} />
                        </div>
                    </div>
                    {/* {
                        ratingDetails.length !== 0 ?

                            ratingViewShow ?
                                <div style={{ marginTop: 20,marginBottom:20, backgroundColor: '#fff', paddingLeft: 16,paddingRight:16 }}>
                                    <div style={{ marginTop: 20,marginBottom:20 }}>
                                        <RatingsReview rating={avgRating} ratings1={ratings1} ratings2={ratings2} ratings3={ratings3} ratings4={ratings4} ratings5={ratings5} totalNofRatings={totalRatings} reviews={serviceReviews.length !== 0 ? serviceReviews.length : null} atHomeRatingsFetch={atHomeService} />
                                        <TouchableOpacity onPress={() => { setRatingViewShow(false); setViewMore(false); }} style={[styles.arrowViewStyle, { alignItems: 'center', position: 'absolute', right: 0, top: 0, width: 20, height: 20, borderRadius: 10, backgroundColor: '#fff', justifyContent: 'center' }]}>
                                            <Image source={BackArrow} style={{ transform: [{ rotate: '90deg' }], width: 15, height: 15, tintColor: '#747474' }} />
                                        </TouchableOpacity>
                                    </View>
                                    {
                                        serviceReviews.length !== 0 ?
                                            serviceReviews.length == 1 ?
                                                <View>{reviewsDisplay}</View>
                                                :
                                                <View style={{ marginTop: 15 }}>
                                                    {renderInitialServiceReviews(serviceReviews[0])}
                                                    <View style={[styles.horizontalLine, { backgroundColor: '#e8e8e8' }]} />
                                                    <TouchableOpacity onPress={() => setViewMoreHandler()} style={{ flexDirection: 'row', alignItems: 'center', justifyContent: 'center', paddingVertical: 20, paddingHorizontal: 16, backgroundColor: '#fff' }}>
                                                        <Text style={styles.showMoreLessTxtStyle}>{viewMore ? "Show Less" : "Show More"}</Text>
                                                        <TouchableOpacity onPress={() => setViewMoreHandler()} style={[styles.arrowViewStyle, { marginLeft: 6, alignItems: 'center', width: 20, height: 20, borderRadius: 10, borderStyle: 'solid', borderWidth: 1, borderColor: '#747474', backgroundColor: '#fff', justifyContent: 'center' }]}>
                                                            <Image source={BackArrow} style={{ transform: [viewMore ? { rotate: '90deg' } : { rotate: '270deg' }], width: 12, height: 12, tintColor: '#747474' }} />
                                                        </TouchableOpacity>
                                                    </TouchableOpacity>
                                                    {
                                                        viewMore &&
                                                        <View>{reviewsDisplay}</View>
                                                    }
                                                </View>
                                            : null
                                    }
                                </View>
                                :
                                <TouchableOpacity onPress={() => setRatingViewShow(true)} style={{ flexDirection: 'row', justifyContent: 'space-between', paddingVertical: 20, paddingHorizontal: 16, marginTop: 15, backgroundColor: '#fff' }}>
                                    <Text style={styles.ratingReviewTxtStyle}>RATINGS & REVIEWS</Text>
                                    <TouchableOpacity onPress={() => setRatingViewShow(true)} style={[styles.arrowViewStyle, { alignItems: 'center', width: 20, height: 20, borderRadius: 10, backgroundColor: '#fff', justifyContent: 'center' }]}>
                                        <Image source={BackArrow} style={{ transform: [{ rotate: '270deg' }], width: 15, height: 15, tintColor: '#747474' }} />
                                    </TouchableOpacity>
                                </TouchableOpacity>
                            : null
                    } */}
                    <div style={{marginTop:10,padding:20,display:'flex',flexDirection:'column',backgroundColor:'#fff'}}>
                        <text className='whyChooseUsText'>WHY CHOOSE US?</text>
                        <div style={{display:"flex",flexDirection:'row',marginTop:20,justifyContent:'space-around',alignItems:'center'}}>
                            <div style={{display:'flex',flexDirection:'column',alignItems:'center'}}>
                                <img src={Fee} style={{ marginBottom: 13,width:50,height:40 }} />
                                <text className='reasonsStyle'>No Hidden Fees</text>
                            </div>
                            <div style={{display:'flex',flexDirection:'column',alignItems:'center'}}>
                                <img src={Certified} style={{ marginBottom: 15,width:50,height:40 }} />
                                <text className='reasonsStyle'>Certified Professionals</text>
                            </div>
                            <div style={{display:'flex',flexDirection:'column',alignItems:'center'}}>
                                <img src={Convenience} style={{ marginBottom: 13 ,width:50,height:40}} />
                                <text className='reasonsStyle'>Convenience</text>
                            </div>
                        </div>
                    </div>
                    <>
                        <BookAserviceWithUs />
                    </>
                {/* </div> */}
            </div>
        </div>
    );
}